export default __webpack_public_path__ + "static/media/47_desktop.4435527e.jpg";